import moment from 'moment';
import { FilterValues, InputValuesType } from './types';

export const filterOutEmptyAndFormat: (obj: { [key: string]: { fieldName: string; value: any } }) => {
  [key: string]: any;
} = (obj) =>
  Object.values(obj).reduce((previous, fieldState) => {
    const hasValue = (() => {
      if (fieldState.value !== undefined) {
        if (Array.isArray(fieldState.value) && fieldState.value.length) {
          return fieldState.value.some((v: any) => v !== undefined && v !== '');
        } else if (Array.isArray(fieldState.value) && !fieldState.value.length) {
          return false;
        } else {
          return fieldState.value !== undefined && fieldState.value !== '';
        }
      }

      return false;
    })();

    const fieldValue =
      Array.isArray(fieldState.value) && fieldState.value.length === 1 ? fieldState.value[0] : fieldState.value;

    return {
      ...previous,
      ...(hasValue ? { [fieldState.fieldName]: fieldValue } : {}),
    };
  }, {});

export const convertStringToDate: (val: string) => Date = (val) => {
  const momentDateFormat = moment(val, 'DD-MM-YYYY', true);
  return momentDateFormat.toDate();
};

export const checkIfStringIsDate: (val: string) => boolean = (val) => {
  const momentDateFormat = moment(val, 'DD-MM-YYYY', true);
  return momentDateFormat.isValid();
};

export const fromStringToValue: (val: string) => any = (val) => {
  return val === 'null' ? null : val;
};

export const fromValueToString: (val: InputValuesType) => string = (val) => {
  return val === null ? 'null' : val.toString();
};

export const getOppositeKey: (key: string) => string | null = (key) => {
  if (key.endsWith('Min')) return key.slice(0, -3) + 'Max';
  if (key.endsWith('Max')) return key.slice(0, -3) + 'Min';
  if (key.endsWith('After')) return key.slice(0, -5) + 'Before';
  if (key.endsWith('Before')) return key.slice(0, -6) + 'After';
  return null;
};
